/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const lpExternalLawyerStyle = {
  titleContainer: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      paddingTop: "4rem",
      paddingBottom: "9rem",
    },
  }),
  advantage: (theme: Theme) => ({
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: "1.5rem",
    paddingBottom: "2rem",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "3rem",
    },
  }),
  applicationSectionContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.primaryPale,
    paddingTop: "3rem",
    paddingBottom: "3rem",
    [theme.breakpoints.up("md")]: {
      paddingTop: "6rem",
      paddingBottom: "9rem",
    },
  }),
};
